import { InterventionTemplate } from "@/types/intervention-template";
import { postData } from "./axios-service";

function interventionTemplateMapper(inputInterventionTemplate: any): InterventionTemplate {
    return {
        id: inputInterventionTemplate.id,
        productType: inputInterventionTemplate.productType,
items: inputInterventionTemplate.items || []
        
    };
}

export async function postInterventionTemplate(template: InterventionTemplate): Promise<InterventionTemplate> {
    const response = await postData("/intervention-templates", template);
    return interventionTemplateMapper(response);
}